<template>
    <a-config-provider :locale="zhCN">
        <div id="box">
            <router-view/>
        </div>
    </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import moment from 'moment'
import 'moment/dist/locale/zh-cn'
moment.locale('cn')
export default {
    name: 'App',
    setup() {
        return {
            zhCN
        }
    }
}
</script>

<style>
    body {
        background: #f6f6f6;
        font-family: Source Han Sans CN;
        -webkit-user-select: none;   /* 禁止选中文本（如无文本选中需求，此为必选项） */
        user-select: none;
        height: 100%;
    }
    #box {
        overflow-x: hidden;
         height: 100%;
    }
</style>
